// src/components/articles/ArticleCard.jsx
import { useMemo, useState } from "react";
import { FiImage } from "react-icons/fi";

function normalizeUrl(u = "") {
  const s = u.trim();
  if (!s) return "";
  const withProto = s.startsWith("//") ? `https:${s}` : s;
  try {
    const url = new URL(withProto);
    url.pathname = url.pathname
      .split("/")
      .map((seg) => encodeURIComponent(decodeURIComponent(seg)))
      .join("/");
    return url.toString();
  } catch {
    return encodeURI(withProto);
  }
}

const ArticleCard = ({
  href = "#",
  imageUrl,
  image,
  alt,
  date = "Mar 15, 2024",
  category = "Tutorial",
  title = "Getting Started with shadcn/ui: A Complete Guide",
}) => {
  const [imgError, setImgError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const rawSrc = (imageUrl || image || "").trim();
  const src = useMemo(() => normalizeUrl(rawSrc), [rawSrc]);

  return (
    <article
      className="
        bg-cardLight dark:bg-cardDark 
        text-textLight dark:text-textDark
        rounded-xlx overflow-hidden 
        border border-borderLight dark:border-borderDark
        shadow-md dark:shadow-dark
        hover:shadow-lg hover:-translate-y-1
        transition-all duration-300
        p-3
      "
    >
      {/* Image */}
      <a
        href={href}
        className="block relative group rounded-xl overflow-hidden"
      >
        <div className="w-full aspect-[16/11] relative rounded-xl overflow-hidden">
          {src && !imgError ? (
            <img
              src={src}
              alt={alt || title}
              className={`block w-full h-full object-cover transition-all duration-500 
                ${loaded ? "opacity-100 scale-100" : "opacity-0 scale-95"}
                group-hover:scale-105
              `}
              loading="lazy"
              decoding="async"
              onLoad={() => setLoaded(true)}
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="w-full h-full bg-muted/20 dark:bg-white/10 flex items-center justify-center rounded-xl">
              <FiImage className="w-6 h-6 text-muted dark:text-text/70" />
            </div>
          )}

          {/* Date Badge */}
          <span className="absolute top-3 left-3 bg-primary text-white text-[11px] font-semibold px-2 py-1 rounded-md shadow-md">
            {date}
          </span>
        </div>
      </a>

      {/* Title */}
      <a href={href} className="no-underline">
        <h3
          className="
            mt-3 text-[15px] font-semibold leading-snug 
            text-textLight dark:text-textDark 
            hover:text-primary transition-colors duration-300
          "
        >
          {title}
        </h3>
      </a>

      {/* Read More */}
      <a
        href={href}
        className="
          mt-2 inline-block text-sm text-primary font-medium 
          hover:underline transition-all
        "
      >
        Read more →
      </a>
    </article>
  );
};

export default ArticleCard;
